// extracted by mini-css-extract-plugin
export default {"formGroup":"select_formGroup__aVhrI","error":"select_error__tzcwR"};